import { actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  agentsDetail: {},
  agentsCount: null,
  agentsList: [],
  modulesDetail: {},
  modulesCount: null,
  modulesList: [],
  approvalsDetail: {},
  approvalsCount: null,
  approvalsList: [],
  decisionsDetail: {},
  decisionsCount: null,
  decisionsList: [],
  executionsDetail: {},
  executionsCount: null,
  executionsList: [],
  insightsDetail: {},
  insightsCount: null,
  insightsList: [],
  inboxDetail: {},
  inboxCount: null,
  inboxList: [],
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
